import React, { useEffect } from "react";
import NotificationPanels from "./NotificationPanels";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { getLogout } from "../Actions/logoutAction";
import { useDispatch, useSelector } from "react-redux";
import tick from '../assets/img/tick-green-big-icon.svg';


function ArnThankyou(){
  const dispatch = useDispatch();

    const logoutHandler = () => {
        setTimeout(() => {
          dispatch(getLogout())
        }, 5000)
      };

      const storeOtpArnData = useSelector((state) => state.verifyOtpArn);
      const { otpArnData, load, err } = storeOtpArnData;

      const storeArnAuthorizationData = useSelector((state) => state.arnAuthorization);
      const { arnAuthorizationData, loading, error } = storeArnAuthorizationData;
      

      useEffect(()=>{
        logoutHandler();
      },[]);

    return (
        <>
      <NotificationPanels />
      <Header firstName={otpArnData?.data?.username}  />
      <Sidebar />
      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {/* {isLoading && <Loader />} */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 w-100-mbl bg-gray-mbl">
              <div class="auth_thankyou  mt-5">
                <div class="container text-center">
                <img src={tick} />
                <h3>Thank you for completing your Authorization  </h3>
                <p>You will be logged off automatically in  5 Seconds</p>
              </div>
              </div>
            </div>
             </div>
            </div>
            </section>
        </>
    )
}

export default ArnThankyou;